// Document types required for merchant verification
export var DocumentType;
(function (DocumentType) {
    DocumentType["BUSINESS_REGISTRATION"] = "business_registration";
    DocumentType["MAYORS_PERMIT"] = "mayors_permit";
    DocumentType["SANITARY_PERMIT"] = "sanitary_permit";
    DocumentType["BIR_CERTIFICATE"] = "bir_certificate";
    DocumentType["FIRE_SAFETY_CERTIFICATE"] = "fire_safety_certificate";
    DocumentType["BARANGAY_CLEARANCE"] = "barangay_clearance";
    DocumentType["FOOD_HANDLERS_CERTIFICATE"] = "food_handlers_certificate";
    DocumentType["FDA_LICENSE"] = "fda_license";
})(DocumentType || (DocumentType = {}));
// Document status
export var DocumentStatus;
(function (DocumentStatus) {
    DocumentStatus["PENDING"] = "pending";
    DocumentStatus["APPROVED"] = "approved";
    DocumentStatus["REJECTED"] = "rejected";
})(DocumentStatus || (DocumentStatus = {}));
// Audit action types
export var VerificationAction;
(function (VerificationAction) {
    VerificationAction["APPROVED"] = "approved";
    VerificationAction["REJECTED"] = "rejected";
    VerificationAction["RESET"] = "reset";
})(VerificationAction || (VerificationAction = {}));
// Required document types for MVP
export const REQUIRED_DOCUMENTS = [
    DocumentType.BUSINESS_REGISTRATION,
    DocumentType.MAYORS_PERMIT,
    DocumentType.SANITARY_PERMIT,
];
// Optional document types
export const OPTIONAL_DOCUMENTS = [
    DocumentType.BIR_CERTIFICATE,
    DocumentType.FIRE_SAFETY_CERTIFICATE,
    DocumentType.BARANGAY_CLEARANCE,
    DocumentType.FOOD_HANDLERS_CERTIFICATE,
    DocumentType.FDA_LICENSE,
];
// Allowed file types
export const ALLOWED_MIME_TYPES = [
    'application/pdf',
    'image/jpeg',
    'image/jpg',
    'image/png',
];
// Max file size (10MB)
export const MAX_FILE_SIZE = 10 * 1024 * 1024; // 10MB in bytes
// Document type labels for UI
export const DOCUMENT_TYPE_LABELS = {
    [DocumentType.BUSINESS_REGISTRATION]: 'Business Registration (DTI or SEC Certificate)',
    [DocumentType.MAYORS_PERMIT]: "Mayor's Permit (Business Permit)",
    [DocumentType.SANITARY_PERMIT]: 'Sanitary Permit / Health Certificate',
    [DocumentType.BIR_CERTIFICATE]: 'BIR Certificate of Registration',
    [DocumentType.FIRE_SAFETY_CERTIFICATE]: 'Fire Safety Inspection Certificate',
    [DocumentType.BARANGAY_CLEARANCE]: 'Barangay Clearance',
    [DocumentType.FOOD_HANDLERS_CERTIFICATE]: "Food Handler's Certificate",
    [DocumentType.FDA_LICENSE]: 'FDA License to Operate',
};
